<template>
  <div class="consultant-list">
    <search-input
      v-model="consultantName"
      placeholder-word="输入顾问姓名搜索"
      @on-search="search">
    </search-input>
    <div class="consultant-list-wrap">
      <div
        v-for="(item, index) in currConsultantList"
        :key="index + '1'"
        class="consultant-item"
        @click="handleSelectConsultant(item)">
        <div class="consultant-item-content">
          <p class="name">{{ item.name }}</p>
          <p class="roles">{{ item.roles.join('、') }}</p>
        </div>
      </div>
    </div>
    <p class="empty-data" v-if="!currConsultantList.length">未搜索到该员工，请先添加员工账号</p>
  </div>
</template>

<script>
import SearchInput from '../components/SearchInput'

export default {
  components: {
    SearchInput
  },
  data() {
    return {
      consultantName: '',
      consultantList: [],
      currConsultantList: []
    }
  },
  async mounted() {
    await this.getData()
    this.currConsultantList = this.consultantList.map(ele => ele)
  },
  methods: {
    async getData() {
      const res = await this.$rest.cou.getEmployees()
      if (res.code !== 0) return
      this.consultantList = res.data
    },
    search() {
      this.currConsultantList = this.consultantList.filter(ele => ele.name.search(this.consultantName) !== -1)
      console.log(this.consultantName, 'search')
    },
    handleSelectConsultant(consultant) {
      this.$store.dispatch('UPDATE_CONSULTANT', consultant)
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/base/fn";
  .consultant-list {
    min-height: 100%;
    background-color: #fff;
    overflow: scroll;
    .empty-data {
      text-align: center;
      padding: 100/@w2 0;
    }
  }
  .consultant-list-wrap {
    padding: 0 30/@w2;
  }
  .consultant-list {
    .consultant-item {
      padding: 20/@w2 10/@w2;
      box-shadow: 0px 1px 0px 0px
      #d9d9d9;
      .name {
        font-size: 15px;
        color: #333333;
        margin-bottom: 10/@w2;
      }
      .roles {
        width: 100%;
        font-size: 12px;
        line-height: 20px;
        color: #989ea9;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
